import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const CMSContext = createContext(null);

export const CMSProvider = ({ children }) => {
  const [cmsData, setCmsData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCMS = useCallback(async () => {
    try {
      const baseUrl = window.API_URL || 'http://localhost:8000';
      const res = await axios.get(`${baseUrl}/cms`);
      if (res.data && typeof res.data === 'object') {
        setCmsData(res.data);
      }
    } catch (err) {
      console.error('Error fetching CMS content:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCMS();
  }, [fetchCMS]);

  const value = {
    cmsData,
    loading,
    refreshCMS: fetchCMS,
    // Helper to get section with fallback
    getSection: (sectionKey, fallback = {}) => {
      if (cmsData && cmsData[sectionKey]) {
        return { ...fallback, ...cmsData[sectionKey] };
      }
      return fallback;
    }
  };

  return (
    <CMSContext.Provider value={value}>
      {children}
    </CMSContext.Provider>
  );
};

export const useCMS = () => {
  const context = useContext(CMSContext);
  if (!context) {
    return {
      cmsData: null,
      loading: false,
      refreshCMS: () => {},
      getSection: (_key, fallback = {}) => fallback
    };
  }
  return context;
};

export default CMSContext;
